import axios from 'axios';
import { listGeofencesQuery } from './queries';

const listGeofences = async ({ type, ids, filterDeleted = true, filterParams }) => {
    try {
        const query = listGeofencesQuery({ type, ids, filterDeleted, filterParams });
        const { data } = await axios.get(query);

        return data;
    } catch (error) {
        return { error };
    }
};

export default listGeofences;
